// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pvw3theHiMchUGKfL6v2{flex-direction:column;flex-grow:1;margin:0 16px;display:flex;position:relative}.W4yfgMCcqv8mC4gbowif{align-items:center;padding-top:4px}.mbZfMTIxOGMRwV98K4ex{height:20px;padding-left:8px;font-size:16px}.mbZfMTIxOGMRwV98K4ex::placeholder{color:var(--content-neutral-primary)}.RxYY3oQUu7Y4Tfv6HyQt{flex-grow:1;margin-top:8px;display:flex;position:relative}.r1dJJiklvmIu5K7lIM7d{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `pvw3theHiMchUGKfL6v2`,
	"searchWrap": `W4yfgMCcqv8mC4gbowif`,
	"search": `mbZfMTIxOGMRwV98K4ex`,
	"table": `RxYY3oQUu7Y4Tfv6HyQt`,
	"cellWrapper": `r1dJJiklvmIu5K7lIM7d`
};
export default ___CSS_LOADER_EXPORT___;
